/**
 * Paths starting with `/ntapi` are not under the usual `/api` axios baseURL.
 * Resolving with `new URL('/ntapi/...', VITE_API_URL)` anchors to the host so the
 * request hits `/ntapi/...` instead of `/api/ntapi/...`.
 *
 * @param {string} apiPath
 * @returns {string}
 */
export function resolveNtapiRequestUrl(apiPath) {
  if (typeof apiPath !== 'string' || !apiPath.startsWith('/ntapi')) {
    return apiPath
  }
  const base = import.meta.env.VITE_API_URL
  if (!base) return apiPath
  try {
    return new URL(apiPath, base).href
  } catch {
    return apiPath
  }
}
